var _a;
import { __decorate, __metadata } from "tslib";
import { Component } from 'decorators';
import template from './setDescription.view.html';
import { AiAgentSidebarStateService } from '../../../aiAgent/services/AiAgentSidebarStateService';
let SetDescriptionComponent = class SetDescriptionComponent {
    static $inject = ['AiAgentSidebarStateService'];
    constructor(AiAgentSidebarStateService) {
        this.AiAgentSidebarStateService = AiAgentSidebarStateService;
        this.onDescriptionChange = (event) => {
            const description = event.detail.value;
            this.onDescriptionChanges({ description });
        };
        this.actionBlur = () => {
            this.onActionBlur(this.action);
        };
    }
    $onInit() {
        if (!this.action.$description) {
            this.action.$description = '';
        }
    }
    openSchemaEditor() {
        this.AiAgentSidebarStateService.close();
        this.onOpenSchemaEditor(this.action);
    }
};
//#endregion
SetDescriptionComponent.$inject = ['AiAgentSidebarStateService'];
SetDescriptionComponent = __decorate([
    Component({
        controllerAs: '$ctrl',
        template: template,
        bindings: {
            action: '=',
            onDescriptionChanges: '&',
            onOpenSchemaEditor: '&',
            onActionBlur: '&',
        },
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof AiAgentSidebarStateService !== "undefined" && AiAgentSidebarStateService) === "function" ? _a : Object])
], SetDescriptionComponent);
export { SetDescriptionComponent };
